import get from 'lodash/get';
import env from 'utils/env';
import isPublicPage from 'utils/public-pages';
import cookie from 'utils/cookie';

function handleUnauthorizedReq() {
  window.location.replace(
    `https://login.${env.hostname}?origin=${window.location.href}`
  );
  // Returning a promise that never resolves so that we can await this function call,
  // which allows us to ensure that no code is executed after this function returns.
  // In doing so, we eliminate a possible race condition where a later line of code
  // could send the user to a page other than the login page, like the oops page.
  return new Promise(() => {});
}

async function requestJson(path, method, headers, body) {
  const isLocalAceApi = path.includes('localhost:8089');
  const defaultHeaders = {
    'FFF-Auth': 'V1.1',
    Accept: 'application/vnd.fabfitfun.v2+json',
    Origin: env.hostname,
    ...(isLocalAceApi && {
      Authorization: `Bearer ${cookie.get('Jwt')}`,
    }),
  };

  const response = await fetch(path, {
    headers: { ...defaultHeaders, ...headers },
    data: {
      activatedOn: true,
    },
    body,
    mode: 'cors',
    method,
    ...(!isLocalAceApi && { credentials: 'include' }),
  });

  // only redirect to login page if the request is to an ace-api endpoint
  if (path.match(/ace-api/) && response.status === 401 && !isPublicPage) {
    await handleUnauthorizedReq();
  }

  const parsedResponse = await response.json();
  if (!response.ok || get(parsedResponse, 'error')) throw parsedResponse;
  return parsedResponse;
}

export default requestJson;
